import { onMounted, ref } from 'vue';

import { client } from '@/shared/api/apiClient';

type MovementTypeItem = {
  readonly label_phrase?: string;
  readonly str?: string;
};

type MovementTypesResponse = {
  readonly movement_type?: readonly MovementTypeItem[];
};

type MovementTypesResponses = {
  readonly 200: MovementTypesResponse;
};

export type MovementTypeLabels = Readonly<Record<string, string>>;

const defaultMovementTypeLabels: MovementTypeLabels = {
  bicycle: 'На велосипеде',
  bus: 'На автобусе',
  car: 'На автомобиле',
  foot: 'Пешком',
  motorcycle: 'На мотоцикле',
  museum: 'В музее',
  other: 'Другое',
  room: 'В помещении',
  watership: 'На кораблике',
};

let movementTypesRequest: Promise<MovementTypeLabels> | undefined;

// Собирает словарь кодов передвижения и локализованных фраз из справочника API.
const createMovementTypeLabels = (data: MovementTypesResponse | undefined): MovementTypeLabels => {
  return (data?.movement_type ?? []).reduce<Record<string, string>>(
    (labels, movementType) => {
      if (movementType.str && movementType.label_phrase) {
        labels[movementType.str] = movementType.label_phrase;
      }

      return labels;
    },
    { ...defaultMovementTypeLabels },
  );
};

// Загружает справочник один раз на экземпляр MFE и оставляет рабочий fallback при ошибке API.
const loadMovementTypeLabels = async (): Promise<MovementTypeLabels> => {
  if (!movementTypesRequest) {
    movementTypesRequest = client
      .get<MovementTypesResponses>({ url: '/api/web/v1/movement-types/' })
      .then((response) => createMovementTypeLabels(response.data))
      .catch(() => defaultMovementTypeLabels);
  }

  return movementTypesRequest;
};

// Возвращает реактивный справочник для адаптера карточки с локальным fallback до ответа API.
export const useMovementTypeLabels = () => {
  const movementTypeLabels = ref<MovementTypeLabels>(defaultMovementTypeLabels);

  onMounted(() => {
    void loadMovementTypeLabels().then((labels) => {
      movementTypeLabels.value = labels;
    });
  });

  return { movementTypeLabels };
};
